import {
  Component,
  ChangeDetectionStrategy,
  input,
  TemplateRef,
  inject,
  OnInit,
  HostListener,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-z-dialog',
  templateUrl: './z-dialog.component.html',
  styleUrls: ['./z-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ZDialogComponent implements OnInit {
  readonly dialogRef: MatDialogRef<ZDialogComponent> = inject(
    MatDialogRef<ZDialogComponent>
  );

  readonly title = input<string>();
  readonly customTitleTemplate = input<TemplateRef<unknown>>();
  readonly contentTemplate = input<TemplateRef<unknown>>();
  readonly actionButtonsTemplate = input<TemplateRef<unknown>>();
  readonly allowClose = input<boolean>(true);

  ngOnInit(): void {
    this.dialogRef.disableClose = true;
  }

  @HostListener('window:keyup.esc') onKeyUp() {
    if (this.allowClose()) {
      this.dialogRef.close();
    }
  }
}
